// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__16F_w","label":"CategoryService_label__11bQE","location":"CategoryService_location__1WU2A"};